export const filterBreaklines = (item: any): boolean => !item.text;
